import * as React from "react";
import AuthService from "../../Components/auth/AuthService";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { Button, Col, Descriptions, Divider, Flex, Input, message, Modal, Row, Table, Tag, Typography } from "antd";
import { useSelector } from "react-redux";
import moment from "moment";
import { ArrowLeftOutlined, CalendarOutlined, CodeFilled, EditFilled, TagsFilled } from "@ant-design/icons";
import { locationTypes } from "../../Components/common/Constants";
import { get, initial } from "lodash";
import { showMessage } from "../../Components/Utils/message";
import dayjs from "dayjs";
import InfoCards from "../../Components/InfoCards";
import CustomTag from "../../Components/CustomTag";
import DetailsGrid from "../../Components/common/DetailsGrid";
import { decodeId, encodeId } from "../../Components/common/CommonFun";

const Auth = new AuthService();

export default function UpdateCycleCount(props) {
  const navigate = useNavigate();
  const params = useParams();
    const decodedID = decodeId(params?.id)

  var layoutDispatch = useLoadingDispatch();
  const { Text } = Typography;
  const { products, locations, aisles } = useSelector((state) => state.AppState?.userCreds);
  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [cycleDetails, setCycleDetails] = React.useState({
    count_date: null,
    category: null,
    sub_category: [],
    posted: false,
    cycleCountItems: [],
    cycleCountItemsQuantities: [],
    code: '',
    converted: false,
    adjustment_id: null,
    adjustment_code: null
  });

  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [selectedProductQuantities, setSelectedProductQuantites] = React.useState([]);

  const getCountCycleByID = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/cycle-count?id=${id}`);
      if (res?.ack) {
        const sub = JSON.parse(res?.cycle_count.sub_category);

        setCycleDetails({
          ...cycleDetails,
          count_date: res?.cycle_count.count_date,
          code: res?.cycle_count.cycle_count_code,
          converted: res?.cycle_count.wms_inventory_adjustment_id > 0 ? true : false,
          adjustment_id: res?.cycle_count.wms_inventory_adjustment_id,
          adjustment_code: res?.cycle_count.wms_inventory_adjustment_code,
          category: res?.cycle_count.category,
          sub_category: sub,
          posted: res?.cycle_count.posted_by > 0 ? true : false,
          cycleCountItems: res?.wms_cycle_count_items || [],
          cycleCountItemsQuantities: res?.wms_cycle_count_items_quantities || []
        })

      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  React.useEffect(() => {
    if (id > 0) {
      getCountCycleByID();
    }
  }, [id]);

  const postCycleCount = async () => {
    showLoading(layoutDispatch);

    const dataToSend = {
      id: id,
    };

    try {
      const res = await Auth.fetch(`/stock/post-cycle-count`, {
        method: 'POST',
        body: JSON.stringify(dataToSend),

      });
      if (res?.ack) {
        showMessage('success', res?.message);
        navigate("/cycle-counts");
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  console.log('cycleDetails', cycleDetails);


  const dataCol = [

    {
      title: 'Product',
      render: (record) => {
        if (record?.product_netsuite_id) {
          const product = products?.find(obj => obj.netsuite_id == record?.product_netsuite_id);
          if (product) {
            return `${product?.code} - ${product?.name} `;
          }
        }
        return '';
      }
    },

    {
      title: "Category",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
        return (
          <span>{item ? `${item?.sub_category}` : '-'}</span>
        )

      }
    },
    {
      title: (
        <>
          Current Qty {cycleDetails?.posted && <Tag color="volcano">At Posting</Tag>}
        </>
      ),
      align: "center",
      render: (record) => (
        <>
          <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.current_quantity} </Tag>
          {record?.is_posted && (
            <div>
              <Tag color="volcano">At Posting</Tag>
            </div>
          )}
        </>
      ),
    },

    {
      title: "Physical Qty",
      align: "center",
      render: (record) => {
        return (
          <span>{record?.physical_quantity || 0}</span>
        )
      },
    },
    {
      title: "Updated",
      align: "center",
      render: (record) => {
        const is_updated = cycleDetails?.cycleCountItemsQuantities?.find(item => item.wms_cycle_count_detail_id === record?.id);
        return (
          <>
            {is_updated ? (
              <Tag color='success' style={{ fontWeight: 'bold', fontSize: '15px' }}>YES</Tag>
            ) : (
              <Tag color='error' style={{ fontWeight: 'bold', fontSize: '15px' }}>NO</Tag>
            )
            }
          </>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      render(record) {
        const isDisabled = record?.is_updated;
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <EditFilled onClick={() => handleViewDetails(record)} style={{ fontSize: '25px', cursor: isDisabled ? 'not-allowed' : 'pointer', marginRight: "5px", color: isDisabled ? '#ccc' : '#001529', pointerEvents: isDisabled ? 'none' : 'auto', }} />
          </div>
        );
      },
    },
  ];

  const productLocationsDetailsCol = [

    {
      title: 'Location',
      render: (record) => {
        const selected = locations?.find((item) => item.id == record?.location_id)
        return (
          <>
            {selected?.code || ''}
          </>
        );
      }
    },
    {
      title: 'Aisle',
      render: (record) => {
        const selectedLoc = locations?.find((item) => item.id == record?.location_id)
        const selected = aisles?.find((item) => item.id == selectedLoc?.aisle_id)
        return (
          <>
            {`${selected?.title || ''} ` }
          </>
        );
      }
    },

    // {
    //   title: 'Batch Code',
    //   render: (record) => {
    //     return (
    //       <>
    //         {`${record?.batch_code || ''} `}
    //       </>
    //     );
    //   }
    // },
    
    {
      title: 'Supplier Batch Code',
      render: (record) => {
        return (
          <>
            {`${record?.supplier_batch_code || ''} `}
          </>
        );
      }
    },
    {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },
    
    {
      title: 'Quantity',
      render: (text, record) => {
        const formattedStock = Number(record?.stock_level).toLocaleString();
        return (
          <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{formattedStock}</Tag>

          // <span >
          //   {formattedStock}
          // </span>
        );
      }
    },
    {
      title: 'Physical Qty',
      render: (text, record, index) => {
        return (
          <Input
            placeholder="Quantity"
            type="number"
            disabled={record?.stock_level < 1 || cycleDetails?.posted}
            value={selectedProductQuantities[index]?.counted_quantity || ''}
            onChange={(e) => {
              const value = e.target.value;
              if (e.target.value.includes('.')) return
              if (value < 0) return showMessage('error', 'Quantity cannot be negative');
              const updated = [...selectedProductQuantities];
              updated[index] = {
                ...updated[index],
                counted_quantity: value
              };
              setSelectedProductQuantites(updated);
            }}
          />
        );
      }
    }
  ];

  // if (!cycleDetails?.cycleCountItemsQuantities?.length) {
  //   productLocationsDetailsCol.push(

  //   )
  // }

  const handleViewDetails = (record) => {
    setSelectedProduct(record);
    getProductLocations(record?.product_netsuite_id);
  };

  const onCancelModal = () => {

    setModalVisible(false);
    setSelectedProduct(null);
    setSelectedProductQuantites([])

  };

  const handleOk = async () => {
    const hasMissingQuantity = selectedProductQuantities.some(
  (item) => item.counted_quantity === "" || item.counted_quantity === null || item.counted_quantity === undefined
);
if (hasMissingQuantity) return showMessage('error', "All quantities must be filled in before proceeding!");
    showLoading(layoutDispatch)
    const payload = selectedProductQuantities.map(item => ({
      purchase_order_details_batch_id: item.purchase_order_details_batch_id,
      quantity: item.counted_quantity,
      location_id: item.location_id,
      batch_code: item?.batch_code,
      supplier_batch_code: item?.supplier_batch_code,
      current_quantity: item?.stock_level,
      expiry_date: item?.expiry_date
    }));

    const dataToSend = {
      wms_cycle_count_id: id,
      product_netsuite_id: selectedProduct?.product_netsuite_id,
      wms_cycle_count_detail_id: selectedProduct?.id,
      wms_cycle_count_items: payload
    }
    try {
      const res = await Auth.fetch('/stock/cycle-count-quantities', {
        method: 'POST',
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        showMessage('success', res?.message)

        setModalVisible(false);
        setSelectedProduct(null);
        setSelectedProductQuantites([])
        getCountCycleByID();
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch)

      }
    } catch (err) {
      showMessage('error', 'something went wrong');
      hideLoading(layoutDispatch)
    }


  };

  const getProductLocations = async (product) => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/stock/cycle-count-batches?product_netsuite_id=${product}`)
      if (res?.ack) {
        if (cycleDetails?.cycleCountItemsQuantities?.length > 0) {
          const updatedItems = res?.product_batches.map(item => {
            const existingItem = cycleDetails?.cycleCountItemsQuantities.find(i => (i.purchase_order_details_batch_id === item.purchase_order_details_batch_id) && (i.location_id === item.location_id) && (i.product_netsuite_id === item.product_netsuite_id));
            return {
              ...item,
              counted_quantity: existingItem ? existingItem.quantity : 0,
            };
          });
          setSelectedProductQuantites(updatedItems);
          setModalVisible(true);
        } else {
          const updatedItems = res?.product_batches.map(item => {
            return {
              ...item,
              counted_quantity: 0,
            };
          })
          setSelectedProductQuantites(updatedItems)
          setModalVisible(true);
        }



      } else {
        showMessage('error', res?.message)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const convertToAdjustment = async () => {
    showLoading(layoutDispatch)
    const dataToSend = {
      id: id,
    }
    try {
      const res = await Auth.fetch('/stock/convert-cycle-count', {
        method: 'POST',
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        showMessage('success', res?.message)
        getCountCycleByID();
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch)
      }
    } catch (err) {
      showMessage('error', 'something went wrong');
      hideLoading(layoutDispatch)
    }
  };

  // const infoItems = [
  //   {
  //     label: 'Cycle Count Code',
  //     value: cycleDetails?.code || 'N/A'
  //   },
  //   {
  //     label: 'Cycle Count Date',
  //     value: cycleDetails?.count_date ? dayjs(cycleDetails?.count_date).format('DD-MM-YYYY') : ''
  //   },
  //   {
  //     label: 'Categories',
  //     value: Array.isArray(cycleDetails?.sub_category) ? cycleDetails.sub_category.join(', ') : cycleDetails?.sub_category || ''
  //   },
  // ]

  const infoItems = [
    {
      label: 'Code ',
      value: cycleDetails?.code || 'N/A',
      icon: <CodeFilled style={{ color: "#52c41a" }} />,
      type: 'text',
    },
    {
      label: 'Cycle Count Date',
      value: cycleDetails?.count_date ? dayjs(cycleDetails?.count_date).format('DD-MM-YYYY') : '',
      icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
      type: 'text',
    },
    
  ]
//   const infoItemsCategories = [
// {
//       label: 'Categories',
//       value: Array.isArray(cycleDetails?.sub_category) ? cycleDetails.sub_category.join(', ') : cycleDetails?.sub_category || '',
//       icon: <TagsFilled style={{ color: "#1cd1faff" }} />,
//       type: 'text',
//     }
//   ]


  return (
    <div>
      <Flex justify="space-between" align="center" style={{ marginBottom: '5px' }}>
        <h3 style={{ margin: 0 }}> Cycle Count Quantities </h3>
      <Flex>

        {
          cycleDetails?.posted && (
            <Flex align="center" gap={5} >
              {cycleDetails?.converted ? (
                <CustomTag
                color="blue"
                
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 4,
                  }}
                >
                  <span style={{ fontWeight: 500 }}>Inventory Adjustment:</span>
                  <span
                  onClick={() => {
                    if (cycleDetails?.adjustment_id)
                      navigate(`/transaction-inventory/${encodeId(cycleDetails?.adjustment_id)}`);
                    else
                      showMessage('info', 'No adjustment created for this cycle count');
                  }}
                    style={{
                      fontFamily: 'monospace',
                      fontWeight: 'bold',
                      background: '#dbeafe',
                      color: '#1d4ed8',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                  >
                    {cycleDetails?.adjustment_code || 'N/A'}
                  </span>
                </CustomTag>

              ) : (
                <Button type="primary" onClick={() => {
                  Modal.confirm({
                    title: 'Convert To Inventory Adjustment',
                    content: 'Are you sure you want to convert this cycle count to an inventory adjustment?',
                    onOk: () => convertToAdjustment(),
                    okText: 'Yes',
                    cancelText: 'No',
                    centered: true,
                  })
                }}   >Convert To Inventory Adjustment</Button>
              )}

              <CustomTag color="red" style={{ margin: 0 }}>
                Posted
              </CustomTag>
              
            </Flex>
          )
        }
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/cycle-counts")}>Back</Button>
              </Flex>
      </Flex>
      {/* <InfoCards items={infoItems} maxColumns={3} /> */}
      <DetailsGrid infoItems={infoItems}  />
      {/* <DetailsGrid infoItems={infoItemsCategories} fullWidth={true} /> */}
      <div>
        <Table
          dataSource={cycleDetails?.cycleCountItems}
          pagination={false}
          columns={dataCol}
          style={{ marginTop: '10px', marginBottom: '10px', overflowX: 'auto' }}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
        />
      </div>
      <Flex justify="end" gap={5}>
        {/* <Button onClick={() => navigate('/cycle-counts')}>Cancel</Button> */}
        {
          !cycleDetails?.posted && cycleDetails?.code && (
            <Button type="primary" onClick={() => {
              Modal.confirm({
                title: 'Confirm Post',
                content: 'Are you sure you want to post this cycle count?',
                onOk: () => postCycleCount(),
                okText: 'Yes',
                cancelText: 'No',
                centered: true,
              });

            }}>Post</Button>
          )
        }

      </Flex>
      {/* Modal for Product Locations */}
      <Modal
        title={` Update Cycle Count: ${products?.find((item) => item?.netsuite_id == selectedProduct?.product_netsuite_id)?.code} - ${products?.find((item) => item?.netsuite_id == selectedProduct?.product_netsuite_id)?.name} `}
        open={modalVisible}
        onOk={handleOk}
        onCancel={onCancelModal}
        width={'80vw'}
        okButtonProps={{ disabled: !selectedProductQuantities?.length > 0 || cycleDetails?.posted }}
        okText='Save'
      >
        <>
          <Divider style={{ margin: '2px 2px'}} />
          <div>
          </div>
          <Table
            dataSource={selectedProductQuantities}
            columns={productLocationsDetailsCol}
            pagination={false}
            style={{ marginTop: '10px', }}
            scroll={{ x: 'max-content'}}
            rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          />
        </>

      </Modal>
    </div>
  );
}
